export default __webpack_public_path__ + "static/ti_logo-f69f36e0e03c9fbbd907d416f25776f7.svg";